import { IColumnStyle } from './types';

export const DEFAULT_COLUMN_STYLE: IColumnStyle = Object.freeze({
  minWidth: '50px',
  maxWidth: '200px',
  flexGrow: 1,
  flexShrink: 1,
  width: 100,
  marginRight: 1,
  paddingLeft: 12,
  paddingRight: 12,
  paddingLayer: 'self',
});

export const CELL_SETTINGS = Object.freeze({
  headerHeight: 48,
  cellDataHeight: 80,
  horizontalPadding: 16,
  hasBorderClassName: 'with-border',
  lastColumnDataAttribute: 'data-is-last-column',
});
